import UncontrolledInputCreatableSelect from "../../inputs/UncontrolledInputCreatableSelect";
import UncontrolledInputSearchableSelect from "components/inputs/UncontrolledInputSearchableSelect";
import UncontrolledInputTextarea from "components/inputs/UncontrolledInputTextarea";
import _ from "lodash";
import { trpc2 } from "utils/trpc";

interface Props {
  integrationId: string;
  fieldValue: string;
  fieldError: any;
  onChange: any;
  fullFieldName: string;
}

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export default function EnhancedAsanaRemoteFieldInput({ integrationId, fieldValue, fieldError, onChange, fullFieldName }: Props) {
  const { data } = trpc2.v2.merge.fetchAsanaRemoteFields.useQuery({ integrationId });

  const options =
    data?.map((option: { display_name: string; id: string; field_choices?: { value: string; display_name: string }[] }) => {
      if (fullFieldName.includes(option.display_name) && option.field_choices) {
        return option.field_choices.map((choice: { value: string; display_name: string }) => ({
          value: choice.value,
          label: choice.display_name,
        }));
      }
      return null;
    }) ?? [];

  const filteredOptions = options.flat().filter(notEmpty);

  return filteredOptions.length > 0 ? (
    <div>
      <UncontrolledInputCreatableSelect
        title="value"
        options={filteredOptions}
        val={fieldValue}
        onChange={onChange}
        placeholder={"Single-select"}
        error={fieldError}
      />
    </div>
  ) : (
    <div>
      <UncontrolledInputTextarea
        title="value"
        placeholder="Text"
        value={fieldValue}
        onChange={onChange}
        error={fieldError}
        className="w-[20rem] min-w-[10rem]"
      />
    </div>
  );
}
